module.exports = __webpack_public_path__ + "img/Line.796509dd.svg";